import { MeetingService } from "@/services/meeting/meeting.service";
const _meetingService = new MeetingService();

const setPollAction = ({ commit }, payload: any): void => {
    commit("setPoll", payload);
};

const setPollTimeAction = ({ commit }, payload: any): void => {
    commit("setPollTime", payload);
};

const createPollAction = ({ commit }, { roomId, data, callback, callbackError }) => {
    _meetingService
        .createPoll(roomId, data)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callbackError(error);
        });
};

const votePollAction = ({ commit }, { pollOption, callback, callbackError }) => {
    _meetingService
        .votePoll(pollOption)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callbackError(error);
        });
};

const cancelPollAction = ({ commit }, { pollId, callback, callbackError }) => {
    _meetingService
        .cancelPoll(pollId)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callbackError(error);
        });
};

export default {
    createPollAction,
    setPollAction,
    votePollAction,
    setPollTimeAction,
    cancelPollAction
}